import { FieldValue, FlatData, ProjectState, Record } from './types'

export class FTClient {

  constructor (
    private apiURL: string,
    private projectId: string
  ) {
  }

  /**
   * Загружаем состояние проекта ("глобальные поля")
   */
  async loadProjectState (): Promise<ProjectState> {
    const res = await fetch(this.apiURL + `project/${this.projectId}/state`)
    if (!res.ok) {
      throw new Error(`Can't fetch project state`)
    }
    return res.json()
  }

  /**
   * Загружаем публичные данные (публичные поля) по всем записям
   */
  async loadRecordsPublicData (): Promise<FlatData[]> {
    const res = await fetch(this.apiURL + `project/${this.projectId}/public-data`)
    if (!res.ok) {
      throw new Error(`Can't fetch public data`)
    }
    return res.json()
  }

  async findRecord (field: string, value: FieldValue): Promise<Record | null> {
    const data = {
      projectId: this.projectId,
      field,
      value
    }
    const res = await fetch(this.apiURL + 'record/find', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    if (!res.ok) {
      throw new Error(`Can't find record`)
    }
    const json = await res.json()
    return json.id
      ? json
      : null
  }

  async createRecord (data: FlatData): Promise<Record> {
    const { projectId } = this
    const res = await fetch(this.apiURL + 'record', {
      method: 'POST',
      body: JSON.stringify({ projectId, data }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    if (!res.ok) {
      throw new Error(`Can't create record`)
    }
    return res.json()
  }

  async updateRecord (id: string, data: FlatData): Promise<Record> {
    const res = await fetch(this.apiURL + `record/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    if (!res.ok) {
      throw new Error(`Can't update record`)
    }
    return res.json()
  }
}
